import React, { useContext } from 'react';
import Proptypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import Icon from '../icon/Icon';
import './protection-plan-tooltip.scss';

const ProtectionPlanTooltip = ({ linkUrl, linkText }) => {

  const { channel } = useContext(ExperienceContext);

  const TooltipContent = React.forwardRef((props, ref) => {
    return (
      <div ref={ref} className="hdpp-tooltip-content">

        <div className="hdpp-tooltip-content__header">
          The Home Depot Protection Plan by Allstate
        </div>

        <div className="hdpp-tooltip-content__body">

          <p>Protection plans that get it done</p>

          <ul className="hdpp-tooltip-content__content-list">
            <li>Covers 100% parts and labor for product breakdowns &amp; defects</li>
            <li>No deductibles or hidden fees</li>
            <li>2 or 3-day Service Guarantee. Premium tech support for smart appliances</li>
            <li>30% reimbursement of plan price if no service claims are made</li>
            <li>24/7 customer support &amp; easy online claims</li>
          </ul>

          <p>Covers your product for 3 or 5 years from date of purchase.</p>

          <p>Your protection plan details will be emailed to you after purchase.</p>

          <a
            target="_blank"
            rel="noreferrer"
            href={linkUrl}
            className="u__default-link"
          >
            Plan Details
          </a>

        </div>

        <div className="hdpp-tooltip-content__icon">
          <Icon iconName="allstate-protection-plan">HDPP Allstate Icon</Icon>
        </div>

      </div>
    );
  });

  return (
    <Tooltip channel={channel} closeButton content={<TooltipContent />} interactive>
      <button className="u__default-link" type="button">{linkText}</button>
    </Tooltip>
  );
};

ProtectionPlanTooltip.propTypes = {
  linkUrl: Proptypes.string.isRequired,
  linkText: Proptypes.string.isRequired,
};

export default ProtectionPlanTooltip;